import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import gamesData from '../games.json';
import slotsData from '../slots.json';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import ScrollToTop from '../components/ScrollToTop';
import NotFoundPage from './NotFoundPage';
import './GamePage.css';

function GamePage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Merge games and slots data
  const allGames = useMemo(() => {
    const slots = Array.isArray(slotsData) ? slotsData : [];
    return [...gamesData, ...slots];
  }, []);

  // Find game by slug
  const game = useMemo(() => {
    return allGames.find(g => {
      const gameSlug = g.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      return gameSlug === slug && !g.disabled;
    });
  }, [allGames, slug]);

  // If game not found, show 404
  if (!game) {
    return <NotFoundPage />;
  }

  const seoTitle = `Play ${game.name} - Free Online at iGames.ng`;
  const seoDescription = `Play ${game.name} for free online. ${game.gameType ? `${game.gameType} game` : 'Casino game'} with no download or registration required at iGames.ng`;

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="App">
      <SEO 
        title={seoTitle}
        description={seoDescription}
      />
      <Header />
      <main className="game-page">
        <div className="game-page-header">
          <button className="back-button" onClick={handleBackClick}>
            ← Back to Games
          </button>
          <h1 className="game-page-title">{game.name}</h1>
          {game.provider?.name && (
            <p className="game-page-provider">by {game.provider.name}</p>
          )}
        </div>
        <div className="game-page-container">
          <iframe
            src={game.url || game.gameUrl}
            title={game.name}
            className="game-page-iframe"
            allow="fullscreen; autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
        {(game.gameType || game.rtp || game.themes) && (
          <div className="game-page-info">
            {game.gameType && (
              <div className="game-info-item">
                <strong>Type:</strong> {game.gameType}
              </div>
            )}
            {game.rtp && (
              <div className="game-info-item">
                <strong>RTP:</strong> {game.rtp}%
              </div>
            )}
            {game.themes && game.themes.length > 0 && (
              <div className="game-info-item">
                <strong>Themes:</strong> {game.themes.map(t => t.label).join(', ')}
              </div>
            )}
          </div>
        )}
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default GamePage;
